const GoogleIcon = () => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.8358 8.74465L10.8022 8.7393V12.34H15.9646C15.686 13.864 14.1599 16.644 10.2021 16.644C6.71879 16.644 3.87678 13.7582 3.87678 10.2021C3.87678 6.64596 6.71879 3.76021 10.2021 3.76021C12.1842 3.76021 13.5105 4.60553 14.2684 5.33422L17.0375 2.66714C15.2594 1.0056 12.9567 0 10.2021 0C4.56181 0 0 4.5618 0 10.2021C0 15.8424 4.56181 20.4042 10.2021 20.4042C17.2209 20.4042 20.8362 14.5785 19.8358 8.74465Z'
      fill='white'
    />
  </svg>
)

export default GoogleIcon
